import React from "react"

class CSCOVerticalSection extends React.Component 
{
    constructor(props)
    {
        super(props);
        this.state = 
        {
            mInclude                : true,
            mId                     : this.props.pId,
            mAlign                  : (this.props.pAlign) ? (this.props.pAlign) : 'left',
            mBackgroundColor        : this.props.pBackgroundColor,
            mParent                 : this.props.parent,
            mChildren               : this.props.pChildren,
            mMaxWidth               : this.props.mMaxWidth,
            mMaxSectionItems        : (this.props.pMaxSectionItems) ? this.props.pMaxSectionItems + 0.29 : null ,
            mHeight                 : this.props.pHeight,
            mFormItemHeight         : (this.props.pFormItemHeight) ? this.props.pFormItemHeight : '43px',
            mWidth                  : this.props.pWidth,
            mPadding                : (this.props.pPadding) ? this.props.pPadding : '2px',
            mNumSections            : this.props.pNumSections,
            mCriteriaSectionWidth   : (this.props.pIsCriteriaSection) ? '150px' : '0px',
            mImageSectionWidth      : (this.props.pImageSectionWidth) ? this.props.pImageSectionWidth : '0px'
        };

        if((this.props.pIsCriteriaLabel !== undefined) && (!this.props.pIsCriteriaLabel))
        {
            this.state.mCriteriaSectionWidth = '60px';
        }
    }

    componentDidMount()
    {    
        this.setState({mChildren : this.props.pChildren});
    }

    componentDidUpdate(lPrevProps, lPrevState)
    {
        if(lPrevProps.pChildren !== this.props.pChildren)
        {
            this.setState({mChildren : this.props.pChildren});
        }
    }

    cfGetMaxSectionItems(lLength)
    {
        var lRetVal = lLength;
        if(lLength <= 6)
        {
            lRetVal = lLength + 0.35;
        }
        else if((lLength > 6) && (lLength <= 14))
        {
            lRetVal = lLength - 0.15;
        }
        else if((lLength > 14) && (lLength <= 21))
        {
            lRetVal = lLength + 0.05;
        }
        else if((lLength > 21) && (lLength <= 28))
        {
            lRetVal = lLength;
        }

        return lRetVal;
    }

    render() 
    {
        let lSectionClassName = null;
        
        if((this.props.pId === 0) || (this.props.pNumSections === 1)) {
            if(this.props.pSectionFlag) {
                lSectionClassName="form-vsection field border-left-1 border-right-1 border-bottom-1 border-primary";
            }
            else {
                lSectionClassName="form-vsection field border-1 border-primary";
            }
        }
        else {
            if(this.props.pSectionFlag) {
                lSectionClassName="form-vsection field border-left-none border-right-1 border-bottom-1 border-primary";
            }
            else {
                lSectionClassName="form-vsection field border-left-none border-right-1 border-top-1 border-bottom-1 border-primary";
            }
        }

        if(this.props.pIsCriteriaSection)
        {
            lSectionClassName="form-hsection field";
        }

        let lClassName = "form-align"
        if(this.props.pClassName) {
            lClassName = this.props.pClassName;
        }

        return (
            <div align    = "center"
                key       = { this.state.mId }
                className = { lSectionClassName }>
                <div className={lClassName}>
                    {this.state.mChildren}
                </div>
            </div>
        );
    }
}

export default CSCOVerticalSection;
